// extracted by mini-css-extract-plugin
export default {"modalOverlay":"LI-z","modalContent":"MI-z","header":"NI-z","close":"OI-z"};